type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export const SentrySeverityLevel = {
  Info: 'info' as SeverityLevel,
  Error: 'error' as SeverityLevel,
  Fatal: 'fatal' as SeverityLevel,
  Debug: 'debug' as SeverityLevel,
  Log: 'log' as SeverityLevel,
  Warning: 'warning' as SeverityLevel,
};
